import { useMemo } from 'react';

import { Dialog } from '@repo/videa-components/src/ui/dialog';
import { Provider, useAtom } from 'jotai';

import { ClaimSummaryDialog } from './ClaimSummaryDialog';
import { PageProvider } from './context/PageContext';
import { claimSummaryDialogAtom } from './state';

export const ClaimSummary = () => {
  const [dialogValues, setDialogValues] = useAtom(claimSummaryDialogAtom);

  const key = dialogValues.unifiedId || dialogValues.estimatedVisitId;

  const isDialogOpen = useMemo(() => {
    if (!dialogValues.isOpen) return false;
    return !!key;
  }, [dialogValues.isOpen, key]);

  const handleCloseDialog = () => {
    setDialogValues({
      unifiedId: '',
      estimatedVisitId: '',
      imagingPatientId: '',
      view: 'appointment',
      isOpen: false,
    });
  };

  return (
    <PageProvider>
      <Provider key={key}>
        <Dialog open={isDialogOpen} onOpenChange={handleCloseDialog}>
          {/* Only render child component if the dialog is open */}
          {/* Rendering it when dialog is closed causes bugs and unnecessary api calls */}
          {isDialogOpen && (
            <ClaimSummaryDialog
              onCloseDialog={handleCloseDialog}
              defaultDateOfVisit={dialogValues.patientInfo.dateOfVisit}
              defaultProviderName={dialogValues.patientInfo.providerName}
              defaultPatientName={dialogValues.patientInfo.name}
              defaultPatientDOB={dialogValues.patientInfo.dob}
              defaultInsurancePages={dialogValues.insView}
              defaultInsuranceView={dialogValues.view}
              appointmentVisitId={Number(dialogValues.estimatedVisitId)}
              appointmentPmsAppointmentId={
                dialogValues.appointmentPmsAppointmentId
              }
              appointmentImagingPatientId={dialogValues.imagingPatientId}
              appointmentStart={dialogValues.appointmentStart}
              appointmentUnifiedId={dialogValues.unifiedId}
              imagingPatientId={dialogValues.imagingPatientId}
              imagingVisitId={dialogValues.estimatedVisitId}
            />
          )}
        </Dialog>
      </Provider>
    </PageProvider>
  );
};
